import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import { toast } from "react-toastify";

function EmailSettingsTemplate(props) {

  const { id } = useParams();
  const navigate = useNavigate();
  const [editUser, setEditUser] = useState({
    template_type: "",
    heading: "",
    description: "",
    role_type: "",
  });
  const handleChangeFirstdes = (e) => {
    setEditUser({ ...editUser, description: e });
  };
  const [message, setMessage] = useState("");
  const access_token = localStorage.getItem("access_token");


  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  useEffect(async () => {
    const getUser = async () => {
      const reqData = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/email-template/view/${id}`,
        { headers: headers }
      );
      const resData = await reqData?.json();
      var res = resData?.email_template;
      setEditUser(res);
      // console.log(resData)
      // console.log(res)
    };
    getUser();
  }, []);

  const handleInput = (e) => {
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
  };


  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const editInputvalue = {
      template_type: editUser.template_type,
      heading: editUser.heading,
      description: editUser.description,
      role_type: editUser.role_type,
    };

    let firstApiStatus = false;
    let resultapi = null;
    let resjson = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_Baseurl}/admin/Email-Template/update/${id}`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(editInputvalue),
        }
      );

      resjson = await res.json();

      if (resjson.status === true) {
        firstApiStatus = true;

        resultapi = resjson;
      }
    } catch (error) {
      console.error("Error:", error);
    }

    if (firstApiStatus) {
      // props.setApiresponsealert(resultapi);
      // props.setShowalert(true);
      toast.success(resultapi?.message || "Email Settings Updated Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      if (resjson.status === false) {
        var resultError = resjson;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };



  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   const editInputvalue = {
  //     template_type: editUser.template_type,
  //     heading: editUser.heading,
  //     description: editUser.description,
  //     role_type: editUser.role_type,
  //   };
  //   // console.log(editInputvalue);
  //   let res = await fetch(
  //     `${process.env.REACT_APP_Baseurl}/admin/Email-Template/update/` + id,
  //     {
  //       method: "POST",
  //       headers: headers,
  //       body: JSON.stringify(editInputvalue),
  //     }
  //   );

  //   let resjson = await res.json();
  //   // console.log(resjson)
  //   if (res.status === 200) {
  //     setMessage(resjson.success);
  //     alert("Success");
  //     setTimeout(() => {
  //       navigate("/email_settings");
  //     }, 2000);
  //   } else {
  //     setMessage("Some error Occured");
  //     console.log("Error");
  //     alert("Enter Correct Details");
  //   }
  // };

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      {<AdminBackNavigation path={`${'/email_settings'}`} text="Back" />}
      <AdminSaveHeader heading="Edit Template" saveText="Update" saveMethod={handleUpdate} />
      <FormContainer>
        <Wrapper>
          <MessageLabel text="Template Type" />
          <AdminCustomInput type="text" name="template_type" value={editUser?.template_type} onChange={handleInput} placeHolder={"Enter template type"} />
          <MessageLabel text="Subject" />
          <AdminCustomInput type="text" name="heading" value={editUser?.heading} onChange={handleInput} placeHolder={"Enter subject"} />
          <div className=" text-start mt-2">
            <MessageLabel text="Page Content" />
            <div className="mt-2">
              <JoditEditor
                className="rs-input"
                value={editUser?.description}
                onChange={(e) => {
                  handleChangeFirstdes(e);
                }}
              />
            </div>
          </div>
        </Wrapper>
      </FormContainer>
      <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
        <AdminCustomButton saveMethod={handleUpdate} saveText={"Update"} />
      </div >
    </>
  );
}

export default EmailSettingsTemplate;
